module.exports = __webpack_public_path__ + "img/product_123.0b1a092.webp";